module.exports = __webpack_public_path__ + "static/media/进入弹窗@2x.450e88e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/进入弹窗@2x.png
// module id = 1145
// module chunks = 0